import { Component } from '@angular/core';
import { TableComponent } from "../../../shared/components/table/table.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { GeneralService } from "../../../core/services/general.service";
import { InspectionEvidencesComponent } from "./inspection-evidences/inspection-evidences.component";
import { InspectionMaintenanceComponent } from "./inspection-maintenance/inspection-maintenance.component";
import {AuthService} from "../../../core/services/auth.service";

@Component({
    selector: 'app-inspection-board',
    standalone: true,
    imports: [
        TableComponent
    ],
    templateUrl: './inspection-board.component.html',
    styleUrl: './inspection-board.component.scss'
})
export class InspectionBoardComponent {
    configurationTable: any = {
        "columns": [
            {
                "id": "vi.id",
                "title": "ID",
                "type": "text",
                "placeholder": "",
                "required": false,
                "hide": true
            },
            {
                "id": "v.plates",
                "title": "Placa",
                "type": "text",
                "placeholder": "",
                "required": true,
                "onlyTable": true
            },
            {
                "id": "s.id",
                "title": "Orden de Servicio",
                "type": "text",
                "placeholder": "",
                "required": true,
                "onlyTable": true
            },
            {
                "id": "inspection.type",
                "title": "Tipo",
                "type": "text",
                "placeholder": "",
                "required": true,
                "onlyTable": true
            },
            {
                "id": "vi.inspectionDate",
                "title": "Fecha",
                "type": "datetime",
                "placeholder": "",
                "required": true,
                "onlyTable": true
            },
            {
                "id": "vi.fuelLevel",
                "title": "Nivel Combustible",
                "type": "text",
                "placeholder": "",
                "required": true,
                "onlyTable": true,
                "customRender": (value: any) => {
                    return `${value}%`;
                }
            },
            {
                "id": "vi.km",
                "title": "Kilometraje",
                "type": "text",
                "placeholder": "",
                "required": true,
                "onlyTable": true
            },
            {
                "id": "inspection.incidentTypes",
                "title": "Incidentes",
                "condition": "REPLACE(\n" +
                    "                        REPLACE(\n" +
                    "                            REPLACE(\n" +
                    "                                REPLACE(\n" +
                    "                                    REPLACE(\n" +
                    "                                        vi.incidentTypes,\n" +
                    "                                        'missing_items', 'Elementos faltantes'\n" +
                    "                                    ),\n" +
                    "                                    'mechanical_failure', 'Fallas mecánicas'\n" +
                    "                                ),\n" +
                    "                                'internal_damage', 'Daños internos'\n" +
                    "                            ),\n" +
                    "                            'external_damage', 'Daños externos'\n" +
                    "                        ),\n" +
                    "                        'other', ''\n" +
                    "                    )",
                "type": "text",
                "placeholder": "",
                "required": false,
                "onlyTable": true,
                "customRender": (value: any) => {
                    if (!value || value === '') return '<span class="badge bg-success">Sin incidentes</span>';

                    // Los incidentes ya vienen traducidos desde el backend
                    // Solo necesitamos limpiar comas extra y espacios
                    const incidents = value.split(',')
                        .map((incident: string) => incident.trim())
                        .filter((incident: string) => incident !== ''); // Eliminar vacíos

                    if (incidents.length === 0) {
                        return '<span class="badge bg-success">Sin incidentes</span>';
                    }

                    const badges = incidents.map((incident: string) => {
                        return `<span class="badge bg-warning text-dark me-1">${incident}</span>`;
                    });

                    return badges.join(' ');
                }
            },
            {
                "id": "vi.observations",
                "title": "Observaciones",
                "type": "text",
                "placeholder": "",
                "required": false,
                "onlyTable": true,
                "condition": "CONCAT_WS(\n" +
                    "                        ' | ',\n" +
                    "                        vi.observations,\n" +
                    "                        (SELECT GROUP_CONCAT(description SEPARATOR ' | ')\n" +
                    "                         FROM vehicle_inspection_checklist \n" +
                    "                         WHERE inspectionId = vi.id \n" +
                    "                           AND checklistItem = 'other'\n" +
                    "                           AND isChecked = 1\n" +
                    "                           AND description IS NOT NULL\n" +
                    "                           AND description != '')\n" +
                    "                    )",
                "customRender": (value: any) => {
                    if (!value || value === '') return '-';
                    return value.length > 50 ? value.substring(0, 50) + '...' : value;
                }
            },
            {
                "id": "vi.hasIncidents",
                "title": "Estado",
                "type": "text",
                "placeholder": "",
                "required": false,
                "onlyTable": true,
                "hide": true
            },
            {
                "btnName": "Acciones",
                "actions": [
                    {
                        "btnName": "Ver Evidencias",
                        "textConfirmation": "",
                        "action": {
                            "type": "emmit",
                            "fn": this.viewEvidences.bind(this)
                        },
                        "type": {
                            "type": "btn-icon",
                            "class": 'btn-pill btn-outline-info border border-info',
                            "icons": 'image'
                        }
                    },
                    {
                        "btnName": "Crear Orden de Mantenimiento",
                        "textConfirmation": "",
                        "action": {
                            "type": "emmit",
                            "fn": this.createMaintenanceOrder.bind(this)
                        },
                        "type": {
                            "type": "btn-icon",
                            "class": 'btn-pill btn-outline-warning border border-warning',
                            "icons": 'tool'
                        },
                        "showCondition": (row: any) => {
                            // Solo mostrar si tiene incidentes
                            return row['vi.hasIncidents'] === 1;
                        }
                    }
                ]
            }
        ],
        "config": "inspections",
        "sortColumn": "vi.inspectionDate",
        "sortDirection": "DESC",
        "title": "Hojas de Inspección",
        "filterPrincipal": [],
        "filters": []
    };

    constructor(
        public modal: NgbModal,
        private generalService: GeneralService,
        private authService: AuthService
    ) {}

    /**
     * Abrir modal de evidencias
     */
    viewEvidences(row: any) {
        const modalRef = this.modal.open(InspectionEvidencesComponent, {
            centered: true,
            size: 'xl',
            backdrop: 'static'
        });

        modalRef.componentInstance.inspectionId = row['vi.id'];
        modalRef.componentInstance.vehiclePlates = row['v.plates'];
        modalRef.componentInstance.serviceId = row['s.id'];
    }

    /**
     * Abrir modal para crear orden de mantenimiento
     */
    createMaintenanceOrder(row: any) {
        const modalRef = this.modal.open(InspectionMaintenanceComponent, {
            centered: true,
            size: 'xl',
            backdrop: 'static'
        });

        modalRef.componentInstance.inspectionData = row;
        let userLogged = this.authService.getUser();
        console.log(userLogged);
        modalRef.componentInstance.userId = userLogged.id;
        modalRef.componentInstance.userName = userLogged.name

        modalRef.componentInstance.confirmAction = (data: any) => {
            this.generalService.showMessage('success', 'Orden de mantenimiento creada exitosamente');
            // Aquí puedes recargar la tabla si es necesario
        };
    }
}
